// extracted by mini-css-extract-plugin
module.exports = {"audioWide":"style_audioWide__fv6XH","gap":"style_gap__j9sPZ","banner":"style_banner__ngb3a","hof_banner":"style_hof_banner__XS_xH","layout":"style_layout__D9Dw3"};